// @core/api/endpoints/calendar/list_entity_schedule.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListEntityScheduleResponse,
} from '../../../types/calendar';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/calendar';

/**
 * List entity schedule
 * Returns all scheduled entities of a specific calendar-aware type within a time range. Useful for viewing shifts, appointments, or bookings on a timeline.
 */
export async function ListEntitySchedule(
  target_type: string,
  params?: PaginatedRequest & {
    time_max?: string | number | boolean;
    time_min?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListEntityScheduleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendar/:target_type/schedule`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  const requestOptions = options;
  return client.get<ListEntityScheduleResponse>(requestPath, { ...requestOptions, params });
}
